module.exports = __webpack_public_path__ + "img/info_txt_03.7519fe66.png";